import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as n, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconChevronsDownUp",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, p, _, a) {
  return l(), n("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--chevrons-down-up"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Chevrons Down Up",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.646 7.146a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1-.708.708L6 8.207l-2.146 2.147a.5.5 0 0 1-.708-.708l2.5-2.5Zm-2.5-5.5a.5.5 0 0 1 .708 0L6 3.793l2.146-2.147a.5.5 0 1 1 .708.708l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 0 1 0-.708Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const w = /* @__PURE__ */ s(c, [["render", u]]);
export {
  w as default
};
//# sourceMappingURL=chevrons-down-up.js.map
